var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLandingPages = function SvgLandingPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.927 1.5a2.576 2.576 0 0 1 2.568 2.41l.005.163v13.854a2.576 2.576 0 0 1-2.41 2.568l-.163.005H4.073a2.576 2.576 0 0 1-2.568-2.41l-.005-.163V4.073a2.576 2.576 0 0 1 2.41-2.568l.163-.005h13.854zm1.386 5.146H2.686v11.281c.001.72.55 1.311 1.253 1.379l.133.006h13.854c.72 0 1.311-.55 1.379-1.252l.006-.133V6.646zm-7.136 2.8c.28.094.445.376.4.658l-.024.094-1.979 5.938a.594.594 0 0 1-1.15-.282l.023-.094 1.979-5.937a.594.594 0 0 1 .751-.376zm-3.732 1.14a.594.594 0 0 1 .073.751l-.067.083-1.56 1.56 1.559 1.557a.594.594 0 0 1 .18.38l-.002.108-.016.09a.594.594 0 0 1-.933.323l-.068-.06L5.632 13.4a.594.594 0 0 1-.06-.768l.06-.072 1.98-1.98a.594.594 0 0 1 .833.007zm5.86-.074.084.068 1.979 1.98a.594.594 0 0 1 .06.768l-.06.071-1.98 1.98a.594.594 0 0 1-.906-.758l.067-.082 1.559-1.56-1.56-1.56a.594.594 0 0 1-.112-.662l.051-.09.068-.08a.594.594 0 0 1 .75-.075zm3.622-7.825H6.646v2.771h12.667V4.073a1.388 1.388 0 0 0-1.253-1.379l-.133-.007zm-12.469 0H4.073c-.72.001-1.311.55-1.379 1.253l-.006.133v1.385h2.77v-2.77z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgLandingPages;